import React from "react";
import "./styles.css";
import LanguageIcon from "@mui/icons-material/Language";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import BugReportIcon from "@mui/icons-material/BugReport";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import FlightIcon from "@mui/icons-material/Flight";

const servicesData = [
  {
    id: 1,
    title: "Web Development",
    icon: <LanguageIcon fontSize="medium" />,
    description:
      "End-to-end web application development with a focus on performance, scalability, and seamless user experience. From responsive frontends to robust backend integrations.",
    tags: ["React", "HTML/CSS", "REST APIs", "Responsive Design"],
  },
  {
    id: 2,
    title: "Mobile App Development",
    icon: <PhoneAndroidIcon fontSize="medium" />,
    description:
      "Cross-platform mobile solutions built for reliability and speed. Delivering intuitive interfaces and smooth experiences across iOS and Android platforms.",
    tags: ["React Native", "Cross-Platform", "UI/UX", "Performance"],
  },
  {
    id: 3,
    title: "Automation Testing",
    icon: <PrecisionManufacturingIcon fontSize="medium" />,
    description:
      "Comprehensive automation frameworks designed to accelerate release cycles while maintaining product quality. Covering functional, regression, and end-to-end test suites.",
    tags: ["Selenium", "Cypress", "API Testing", "CI/CD Integration"],
  },
  {
    id: 4,
    title: "Manual Testing",
    icon: <BugReportIcon fontSize="medium" />,
    description:
      "Thorough manual testing strategies that catch what automation misses. Exploratory, usability, and compliance testing tailored to your domain and business requirements.",
    tags: ["Functional Testing", "Regression", "BFSI Domain", "Test Planning"],
  },
];

const clientsData = [
  {
    name: "TripCurv",
    url: "https://tripcurv.com",
    icon: <FlightIcon fontSize="small" />,
    description: "Travel Technology Platform",
  },
];

const Services = () => {
  return (
    <main className="servicesPage">
      <section>
        <h1>Services.</h1>

        {/* Services Grid */}
        <div className="services-grid">
          {servicesData.map((service) => (
            <div className="service-card" key={service.id}>
              <div className="service-card-top">
                <span className="service-icon">{service.icon}</span>
                <span className="service-number">0{service.id}</span>
              </div>
              <h2 className="service-title">{service.title}</h2>
              <p className="service-description">{service.description}</p>
              <div className="service-tags">
                {service.tags.map((tag) => (
                  <span className="service-tag" key={tag}>
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Clients Section */}
        <div className="clients-section">
          <h2 className="clients-heading">Clients.</h2>
          <p className="clients-subtext textFont">
            Trusted by forward-thinking companies to deliver quality that scales.
          </p>

          <div className="clients-grid">
            {clientsData.map((client) => (
              <a
                href={client.url}
                target="_blank"
                rel="noopener noreferrer"
                className="client-card"
                key={client.name}
              >
                <div className="client-logo-wrap">{client.icon}</div>
                <div className="client-info">
                  <p className="client-name">{client.name}</p>
                  <p className="client-desc textFont">{client.description}</p>
                </div>
                <OpenInNewIcon fontSize="small" className="client-arrow" />
              </a>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default Services;